<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { handleNext } from '../tutorialSteps'
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import { useAssetStore } from '@/stores/assetStore.ts'
import { computed } from 'vue'

const playerFlagsStore = usePlayerFlagsStore()
const gameStore = useGameStore()
const assetStore = useAssetStore()

const planetType = computed(() => {
  const planetTypeId = gameStore.player?.homeWorldPlanetType
  if (planetTypeId) {
    const planetTypeData = assetStore.findPlanetTypeById(planetTypeId)
    return planetTypeData?.name || 'Temperate'
  }
  return 'Temperate'
})

const handleNextStep = async () => {
  await handleNext('tutorial_terraforming_end')
  await playerFlagsStore.setFlag('tutorial_complete', 'true')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        Excellent!
      </p>
      <p class="pb-2">
        Depending on the resources you have available, you should probably not try to terraform too many planets at the same time. It will make the process much slower.
      </p>
      <p class="pb-2">
        Remember terraforming will convert a planet to a <span class="text-green-500">{{ planetType }}</span> planet, but it will not change its size.
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        Terraforming does not remove the gravity penalty some planets might have. So you can improve the planet, but not all planets can be converted to a "Paradise".
      </Alert>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        Got it, Thank You!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>